import styled from 'styled-components';

import DialogOverlay from 'xpi-black-ui/Common/Dialog/compose/Overlay/styles';

export default styled.div`
  top: 0;
  left: 0;
  z-index: 50;
  width: 100%;
  height: 100%;
  position: fixed;

  ${DialogOverlay} {
    opacity: 1;
  }
`;

export const DialogWrapper = styled.div`
  top: 71px;
  left: 50%;
  z-index: 2;
  width: 800px;
  background: white;
  position: absolute;
  transform: translateX(-50%);
`;

export const DialogContent = styled.div`
  padding: 24px;
  height: 700px;
  overflow-y: scroll;
`;
